import clubRequest from "../axios";
import { UpdateMerchantVerification } from "./type";

const updateNationalCode = async (command: UpdateMerchantVerification) =>
  (await clubRequest.merchantVerificationNationalCodeUpdate(command)).data;

const getVerificationResult = async () =>
  (await clubRequest.merchantVerificationList()).data;

const updateNationalIDImage = async (image: File) => {
  return (
    await clubRequest.merchantVerificationNationalCardImageUpdate({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      image: image,
    })
  ).data;
};

const verificationService = {
  updateNationalCode,
  updateNationalIDImage,
  getVerificationResult,
};

export default verificationService;
